import { useState } from 'preact/hooks';
import type { Work } from '../../shared/types';
import { thumbUrl } from '../lib/images';

// Copertă: imaginea reală dacă există, altfel o copertă „cartonată” generată din titlu și autor.
const PALETTE = [
  ['#7D361E', '#E9C46A'], ['#1F3A5F', '#E0C27A'], ['#2F4F3A', '#E6D3A3'], ['#5B2A4E', '#EAD7A4'],
  ['#3D3731', '#D9B76E'], ['#8A3B12', '#F2E3C6'], ['#264653', '#E9C46A'], ['#4A3B2A', '#E8D5B0']
];

function hash(s: string) { let h = 0; for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0; return Math.abs(h); }

export function Cover({ work, size = 'md' }: { work: Pick<Work, 'id' | 'title' | 'authors' | 'cover_url'>; size?: 'sm' | 'md' | 'lg' }) {
  const [broken, setBroken] = useState(false);
  const dims = size === 'sm' ? 'w-12 h-[72px] rounded-md' : size === 'lg' ? 'w-40 h-60 rounded-lg' : 'w-full aspect-[2/3] rounded-lg';
  if (work.cover_url && !broken) {
    const src = size === 'lg' ? work.cover_url : thumbUrl(work.cover_url)!;
    return (
      <img src={src} alt={work.title} loading="lazy" referrerpolicy="no-referrer"
        onError={() => setBroken(true)}
        class={`${dims} object-cover bg-cream-200 shadow-book`} />
    );
  }
  const [bg, fg] = PALETTE[hash(work.id || work.title) % PALETTE.length];
  const small = size === 'sm';
  return (
    <div class={`${dims} relative overflow-hidden shadow-book flex flex-col justify-between text-center select-none`}
      style={{ background: `linear-gradient(105deg, rgba(0,0,0,.25) 0 6%, rgba(255,255,255,.08) 6% 7%, transparent 7%), ${bg}`, color: fg }}
      aria-label={work.title}>
      <div class={small ? 'h-1' : 'h-3'} />
      <div class={small ? 'px-1' : 'px-3'}>
        <div class={`font-serif font-bold leading-tight ${small ? 'text-[7px] line-clamp-3' : size === 'lg' ? 'text-lg line-clamp-4' : 'text-[13px] line-clamp-4'}`}>{work.title}</div>
        {!small && <div class="mx-auto my-2 h-px w-8" style={{ background: fg, opacity: .6 }} />}
        {!small && <div class={`${size === 'lg' ? 'text-sm' : 'text-[10px]'} opacity-90 line-clamp-2`}>{work.authors}</div>}
      </div>
      <div class={small ? 'h-1' : 'h-4'} />
    </div>
  );
}
